import React, {
  Suspense,
} from 'react'

import ReactDOM from 'react-dom'

import { TERMLY_CODE_SNIPPET_SUPPORT } from 'constants/domIds'

import PreferencesApp from 'components/PreferencesApp'
import ResourceBlockerApp from 'components/ResourceBlockerApp'

import isUsingGPC from './isUsingGPC'


export function renderResourceBlockerApp({ consentConfig, cookiePolicy, countryCode, website }) {
  const isGPC = isUsingGPC(consentConfig)

  const rootElem = getRootElem()

  render(
    <Suspense
      fallback={ null }
    >
      <ResourceBlockerApp
        consentConfig={ consentConfig }
        cookiePolicy={ cookiePolicy }
        countryCode={ countryCode }
        isGPC={ isGPC }
        rootElem={ rootElem }
        website={ website }
      />
    </Suspense>,
    rootElem
  )
}

export function renderPreferencesApp({ consentConfig, countryCode, website }) {
  const rootElem = getRootElem()

  render(
    <Suspense
      fallback={ null }
    >
      <PreferencesApp
        consentConfig={ consentConfig }
        countryCode={ countryCode }
        rootElem={ rootElem }
        website={ website }
      />
    </Suspense>,
    rootElem
  )
}

// The element these widgets mount into is the element they own, so it is
// the one their text direction belongs on. Naming it here is what keeps
// the provider from having to infer it from the document, which it
// cannot do: our own dashboard embeds this widget, so the element is
// present on the page that renders the banner preview as well.
//
function getRootElem() {
  return document.getElementById(TERMLY_CODE_SNIPPET_SUPPORT)
}

function render(app, rootElem) {
  ReactDOM.render(app, rootElem)
}
